
document.addEventListener('DOMContentLoaded', () => {
	
	window.addEventListener("load", () => {
		toggleDomElLayoutPosOnMatchMedia("(orientation: portrait)", ".container_carousel", '.pageMainSection>div:nth-of-type(3)', 
		'.pageMainSection > div:nth-of-type(4)', '.pageMainSection > div:nth-of-type(4) > picture');
	});
	
	window.addEventListener("resize", () => { 
		toggleDomElLayoutPosOnMatchMedia("(orientation: portrait)", ".container_carousel", '.pageMainSection>div:nth-of-type(3)', 
		'.pageMainSection > div:nth-of-type(4)', '.pageMainSection > div:nth-of-type(4) > picture');
	});
	
	screen.orientation.addEventListener("change", () => {
		toggleDomElLayoutPosOnMatchMedia("(orientation: portrait)", ".container_carousel", '.pageMainSection>div:nth-of-type(3)', 
		'.pageMainSection > div:nth-of-type(4)', '.pageMainSection > div:nth-of-type(4) > picture');
	});
});

function toggleDomElLayoutPosOnMatchMedia(matchMediaCond, selectorEl2Move, selectorOldParentEl, selectorNewParentEl, selectorNewNextSiblingEl) {
	
	const DomEl2move = document.querySelector(selectorEl2Move);
//console.log(DomEl2move);
	const oldParentDomEl = document.querySelector(selectorOldParentEl);
	
	const newParentDomEl = document.querySelector(selectorNewParentEl);
console.log("selectorNewParentEl " + selectorNewParentEl);
//console.log(newParentDomEl);

	const newNextSiblingDomEl = document.querySelector(selectorNewNextSiblingEl);
console.log("selectorNewNextSiblingEl " + selectorNewNextSiblingEl);
//console.log(newNextSiblingDomEl);

	//if (screen.orientation.type = "portrait-primary")

	if (window.matchMedia(matchMediaCond).matches)
		{ 
			newParentDomEl.insertBefore(DomEl2move, newNextSiblingDomEl);
		}
	else 
		{ oldParentDomEl.appendChild(DomEl2move);}
//console.log(newParentDomEl);
}